import { createOutlineIcon } from "../createIcon";

export const CircleOutlineIcon = createOutlineIcon(
  <>
    <path d="M21.6004 11.9999C21.6004 17.3018 17.3023 21.5999 12.0004 21.5999C6.69846 21.5999 2.40039 17.3018 2.40039 11.9999C2.40039 6.69797 6.69846 2.3999 12.0004 2.3999C17.3023 2.3999 21.6004 6.69797 21.6004 11.9999Z" />
  </>,
  "CircleOutlineIcon"
);
